"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchResultsHeaderSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("../SearchResultsHeader/styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchResultsHeaderSkeleton = (param)=>{
    let { className, animation } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.SEARCH_RESULTS_HEADER_SKELETON),
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Inner, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.HeaderSkeleton, {
                        animation: animation
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.QuerySkeleton, {
                        animation: animation
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.QueriesContainer, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.StyledQueryListSectionSkeleton, {
                        numberOfItems: _constants.BRANDS_COUNT,
                        animation: animation
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.StyledQueryListSectionSkeleton, {
                        numberOfItems: _constants.CATEGORIES_COUNT,
                        animation: animation
                    })
                ]
            })
        ]
    });
};
exports.SearchResultsHeaderSkeleton = SearchResultsHeaderSkeleton;
